import clsx from 'clsx'
import { useTranslation } from 'react-i18next'
import { SectionSubtitle, SectionTitle } from '@/features/priceCalculator/PurchaseForm/SectionHeading'
import { yStack } from 'ui/src/patterns/stack'
import { InsuranceAmountSelector, type ProductOfferWithInsuranceAmount } from './InsuranceAmountSelector'

type Props = {
  insuranceAmounts: Array<ProductOfferWithInsuranceAmount>
  selectedInsuranceAmountId: string
  onInsuranceAmountChange: (offerId: string) => void
  className?: string
}

export function InsuranceAmountSection({
  insuranceAmounts,
  selectedInsuranceAmountId,
  onInsuranceAmountChange,
  className,
}: Props) {
  const { t } = useTranslation('purchase-form')

  return (
    <section className={clsx(className, yStack({ gap: 'lg' }))}>
      <div>
        <SectionTitle>{t('OFFER_PRESENTER_INSURANCE_AMOUNT_TITLE')}</SectionTitle>
        <SectionSubtitle>{t('OFFER_PRESENTER_INSURANCE_AMOUNT_SUBTITLE')}</SectionSubtitle>
      </div>

      <InsuranceAmountSelector
        offers={insuranceAmounts}
        selectedOfferId={selectedInsuranceAmountId}
        onValueChange={onInsuranceAmountChange}
      />
    </section>
  )
}
